import { type } from '@ngrx/signals'
import { eventGroup } from '@ngrx/signals/events'

import type { UnlockReadReceiptsResponse } from '@app/modules/messaging/models/api.model'
import type { Conversation } from '@app/modules/messaging/models/conversation.model'
import type { Message } from '@app/modules/messaging/models/message.model'

import type { ConversationReadReceiptsUnlockType } from '../models/conversation-read-receipts-unlock-type.model'

export const readReceiptsEvents = eventGroup({
  source: 'Read Receipts',
  events: {
    unlockReadReceipts: type<{
      conversation: Conversation
      unlockType: ConversationReadReceiptsUnlockType
      message: Message
    }>(),
    unlockReadReceiptsSuccess: type<{
      response: UnlockReadReceiptsResponse
      message: Message
      conversation: Conversation
    }>(),
    unlockReadReceiptsFailure: type<{
      error: any
      profile_id: number
    }>(),
    unlockReadReceiptsEnd: type<void>(),
  },
})
